import { render, staticRenderFns } from "./CheckoutTareas.vue?vue&type=template&id=2edb62a5&"
import script from "./CheckoutTareas.vue?vue&type=script&lang=js&"
export * from "./CheckoutTareas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports